import React, { useRef, useState } from 'react';
import { ISSUER, links } from '../siteData';
import Icon from './Icon';
import { ExternalLink } from './Shared';
export default function IssuerControl() {
  const [status, setStatus] = useState('');
  const addressRef = useRef(null);
  async function copyIssuer() {
    try {
      if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(ISSUER);
      setStatus('Issuer address copied.');
    } catch {
      addressRef.current.focus();
      addressRef.current.select();
      setStatus('Copy unavailable. Address selected—press and hold, or use Ctrl/Cmd+C.');
    }
  }
  return <div className="issuer-block">
    <div className="issuer-label"><label htmlFor="issuer-address">Issuer address</label><ExternalLink href={links.explorer}>XRPSCAN <Icon name="external" /></ExternalLink></div>
    <div className="issuer-control"><input id="issuer-address" ref={addressRef} readOnly value={ISSUER} spellCheck="false" aria-label="Full MAGA issuer address" onFocus={event => event.target.select()} /><button onClick={copyIssuer} aria-label="Copy issuer address"><Icon name={status === 'Issuer address copied.' ? 'check' : 'copy'} /><span>{status === 'Issuer address copied.' ? 'Copied' : 'Copy'}</span></button></div>
    <p className="copy-status" role="status" aria-live="polite">{status}</p>
  </div>;
}
